import React from "react";
import TodoListComponent from "../TodoList";
import { Helmet, HelmetProvider } from '@dr.pogodin/react-helmet';

export default function TodoList(props) {
    return (
     <>
      <Helmet>
        <title>Student Todo List & Task Manager | Student Tools Hub</title>
        <meta name="description" content="Free online todo list and task manager designed for students. Organize assignments, track deadlines, and boost productivity with our calendar-integrated planner." />
        <meta name="keywords" content="student todo list, task manager, assignment tracker, homework planner, study organizer" />
        
        <meta property="og:title" content="Student Todo List & Task Manager" />
        <meta property="og:description" content="Free online todo list and task manager designed for students." />
        <meta property="og:url" content="https://student-tools-hub.vercel.app/todo" />
      </Helmet>
      
    <TodoListComponent {...props} />;
  </>
    );
}
